/************
 Product Buttons
 ************/

// const anchor = document.querySelector('#checkATC')
// const position = anchor.getBoundingClientRect().top + window.scrollY;
//
// document.querySelectorAll('.button').forEach(el => {
//     if (el.id !== 'productATC' && el.id !== 'checkATC') {
//
//         el.addEventListener('click', (event) => {
//             event.preventDefault();
//             window.scrollTo({
//                 top: position,
//                 behavior: 'smooth'
//             });
//         })
//     }
// });

/************
 Product Swiper
 ************/

// setup product swiper
let productImages = new Swiper("#productSwiper", {
    slidesPerView: 1,
    breakpoints: {
        800: {
            spaceBetween: 20,
            pagination: false
        }
    },
    navigation: {
        prevEl: '#productSwiperPrev',
        nextEl: '#productSwiperNext',
    },
    spaceBetween: 40,
});

// thumbnail
document.querySelectorAll(".productThumbnail").forEach(function (element) {
    element.addEventListener("click", function () {
        // determine index
        let index = getElIndex(this);

        // change active slide
        productImages.slideTo(index);
    });
});

/**************
 Product FAQs
 ***************/

document.querySelectorAll('.productFaqTop').forEach(el => {
    let parent = el.closest('.productFaq');
    el.addEventListener('click', function () {
        this.classList.toggle('active');
        parent.querySelector('.productFaqBottom').classList.toggle('active');
    })
})

/**************
 Product ATC
 ***************/

const productFormObserver = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
        if (mutation.type === "attributes") {
            const parsedFinalPrice = parseFloat(mutation.target.getAttribute("data-final-price").replace(currency, ""));
            document.querySelector(".productATCPrice").innerText = ` ${price(parsedFinalPrice * 100)}`;
        }
    });
});

productFormObserver.observe(document.querySelector("#pdpProductForm"), {
    attributes: true //configure it to listen to attribute changes
});

document.querySelector("#productATC").addEventListener("click", async function () {
    this.classList.add("loading");
    const variantId = parseInt(document.querySelector("#pdpProductForm").getAttribute("data-selected-variant"));
    const planId = parseInt(document.querySelector("#pdpProductForm").getAttribute("data-selected-plan"));
    const upsells = document.querySelector("#pdpProductForm").getAttribute("data-upsells")?.split(",");
    const product = {
        items: [
            {
                quantity: 1,
                id: variantId,
            }
        ]
    }

    if (planId) {
        product.items[0].selling_plan = planId;
    }

    if (upsells?.length > 0) {
        upsells.forEach(upsell => {
            product.items.push({
                id: parseInt(upsell),
                quantity: 1,
            })
        })
    }

    await addProduct(product);

    await openCart();

    this.classList.remove("loading");
});

/**************
 Try Respire Buttons
 ***************/
document.querySelectorAll(`.button[href="#"]`).forEach(button => button.addEventListener("click", function (event) {
    event.preventDefault();

    const buyBox = document.querySelector(".checkInner");
    if (buyBox) {
        buyBox.scrollIntoView({
            top: 0,
            behavior: "smooth"
        })
    } else {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    }
}));